import React, { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const ChangePasswordDialog = ({ open, onClose, onSubmit }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState('');

    // Field-specific error states
    const [currentPasswordError, setCurrentPasswordError] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    const resetForm = () => {
  setCurrentPassword('');
  setNewPassword('');
  setConfirmPassword('');
  setCurrentPasswordError('');
  setNewPasswordError('');
  setConfirmPasswordError('');
  setLoading(false);
};


    const validateForm = () => {
        let isValid = true;

        if (!currentPassword.trim()) {
            setCurrentPasswordError('Current password is required');
            isValid = false;
        } else {
            setCurrentPasswordError('');
        }

        if (!newPassword.trim()) {
            setNewPasswordError('New password is required');
            isValid = false;
        } else if (newPassword.length < 6) {
            setNewPasswordError('Password must be at least 6 characters');
            isValid = false;
        } else {
            setNewPasswordError('');
        }

        if (newPassword !== confirmPassword) {
            setConfirmPasswordError('Passwords do not match');
            isValid = false;
        } else {
            setConfirmPasswordError('');
        }

        return isValid;
    };

    const handleSave = () => {
        if (validateForm()) {
            setLoading(true);
            setError('');
            onSubmit({ currentPassword, newPassword });
            setLoading(false);
            onClose();
            resetForm();
        }
    };

    const handleChange = (field, value) => {
        switch (field) {
            case 'currentPassword':
                setCurrentPassword(value);
                setCurrentPasswordError('');
                break;
            case 'newPassword':
                setNewPassword(value);
                setNewPasswordError('');
                break;
            case 'confirmPassword':
                setConfirmPassword(value);
                setConfirmPasswordError('');
                break;
            default:
                break;
        }
    };

    if (!open) return null;


    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-full max-w-sm shadow-lg relative">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
                >
                    &times;
                </button>
                <h2 className="text-lg font-medium mb-4">Edit Password</h2>

                {/* Current Password */}
                <div className="relative mb-4">
                    <input
                        className={`w-full border px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${currentPasswordError ? 'border-red-500' : 'border-gray-300'}`}
                        type={showCurrent ? 'text' : 'password'}
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => handleChange('currentPassword', e.target.value)}
                    />
                    <button
                        onClick={() => setShowCurrent(!showCurrent)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2"
                    >
                        {showCurrent ? <VisibilityOff color='#757575' /> : <Visibility color='#757575' />}
                    </button>
                    {currentPasswordError && <p className="text-red-500 text-sm">{currentPasswordError}</p>}
                </div>

                {/* New Password */}
                <div className="relative mb-4">
                    <input
                        className={`w-full border px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${newPasswordError ? 'border-red-500' : 'border-gray-300'}`}
                        type={showNew ? 'text' : 'password'}
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <button
                        onClick={() => setShowNew(!showNew)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2"
                    >
                        {showNew ? <VisibilityOff color='#757575' /> : <Visibility color='#757575' />}
                    </button>
                    {newPasswordError && <p className="text-red-500 text-sm">{newPasswordError}</p>}
                </div>

                {/* Confirm New Password */}
                <div className="relative mb-4">
                    <input
                        className={`w-full border px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${confirmPasswordError ? 'border-red-500' : 'border-gray-300'}`}
                        type={showConfirm ? 'text' : 'password'}
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <button
                        onClick={() => setShowConfirm(!showConfirm)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2"
                    >
                        {showConfirm ? <VisibilityOff color='#757575' /> : <Visibility color='#757575' />}
                    </button>
                    {confirmPasswordError && <p className="text-red-500 text-sm">{confirmPasswordError}</p>}
                </div>

                <div className="mt-4 flex justify-end">
                    <button
                        onClick={handleSave}
                        type="submit"
                        className={`w-full py-2 rounded-md text-white font-medium ${!loading ? 'bg-black hover:bg-black' : 'bg-gray-200 text-gray-400'}`}
                        disabled={loading}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordDialog;
